import React from 'react';
import {
	Datagrid,
	List,
	Create,
	Edit,
	SimpleForm,
	TextField,
	BooleanField,
	TextInput,
	NumberInput,
	BooleanInput, useEditContext,
} from 'react-admin';
import makeStyles from '@mui/styles/makeStyles';

import { checkLocationLabelUniqueness } from '../model/cloud';


const useStyles = makeStyles({
	warning: {
		color: 'purple',
		fontSize: '0.85em',
	},
});

const validate = ({ id, label = '', region = {} }) => {
	const errors = { region: {} };

	if (!label.trim()) {
		errors.label = 'Заполните поле Label.';
	}

	['latitude',	'latitudeDelta',	'longitude',	'longitudeDelta'].forEach((key) => {
		if (!region[key] && region[key] !== 0) {
			errors.region[key] = `Заполните поле ${key} числовым значением.`;
		}
	});

	if (errors.label || Object.keys(errors.region).some((key) => errors.region[key])) {
		return errors;
	}

	return checkLocationLabelUniqueness(label, id)
		.then((isUniq) => !isUniq && { label: 'Label с таким значением уже существует.' });
};

const DefaultRegionWarningMessage = () => (
	<div className={useStyles().warning}>
		{`Не удаляйте локацию с регионом по умолчанию, пока не назначите другую локацию
			регионом по умолчанию!`}
		<br />
		Локация с регионом по умолчанию обязательно должна быть и должна быть только одна.
	</div>
);


const LocationForm = (props) => {
	const { isDefaultRegion } = props;

	return (
		<SimpleForm {...props} validate={validate}>
			<TextInput label="Label (имя локации)" source="label" />
			<BooleanInput
				label="Включена по умолчанию (галочка в фильтре партнеров)"
				source="defaultValue"
				defaultValue={false}
			/>
			<NumberInput label="latitude" source="region.latitude" />
			<NumberInput label="latitudeDelta" source="region.latitudeDelta" />
			<NumberInput label="longitude" source="region.longitude" />
			<NumberInput label="longitudeDelta" source="region.longitudeDelta" />
			<BooleanInput
				label={
					isDefaultRegion
						? 'Регион по умолчанию'
						: 'Сделать регионом по умолчанию? (Вы уверены?)'
				}
				source="isDefaultRegion"
				defaultValue={false}
				disabled={isDefaultRegion}
			/>
			{isDefaultRegion && <DefaultRegionWarningMessage />}
		</SimpleForm>
	);
};

const EditLocationForm = (props) => {
	const { record: { isDefaultRegion } } = useEditContext();
	return <LocationForm {...props} isDefaultRegion={isDefaultRegion} />;
};

export const EditLocation = (props) => {
	return (
		<Edit {...props}>
			<EditLocationForm />
		</Edit>
	);
};

export const CreateLocation = (props) => {
	return (
		<Create {...props}>
			<LocationForm {...props} />
		</Create>
	);
};


export const ListLocation = (props) => {
	return (
		<List
			{...props}
			title="Локации"
			sort={{ field: 'label', order: 'ASC' }}
		>
			<Datagrid rowClick="edit">
				<TextField label="Label (имя локации)" source="label" />
				<BooleanField label="Включена по умолчанию (галочка в фильтре)" source="defaultValue" />
				<TextField label="latitude" source="region.latitude" />
				<TextField label="latitudeDelta" source="region.latitudeDelta" />
				<TextField label="longitude" source="region.longitude" />
				<TextField label="longitudeDelta" source="region.longitudeDelta" />
				<BooleanField label="Регион по умолчанию?" source="isDefaultRegion" />
			</Datagrid>
		</List>
	);
};
